declare var SimpleBar;
declare var loggedTc;

namespace AgerLMS.WebSite {

    export interface GetFilePathResponse {
        path: string;
        vts: number;
    }

    export interface VideoPlayerAfterLoadHandlerRequest {
        fileVideoPlayer: any;
        lessonId: number;
        totalSeconds: number;
        videoUserLastSecond?: number;
        videoSettings?: string;
        orderItemId?: number;
        fp : GetFilePathResponse;
        showWatermark?: boolean;
        watchPopupActive?: boolean;
        pageHash?: string;
        authHash?: string;
        userId?: number;
        userBased?: boolean;
    }

    export class VideoPlayerAfterLoadHandler {

        fileVideoPlayer: any;
        lessonId: number;
        totalSeconds: number;
        orderItemId: number;
        fp : GetFilePathResponse;
        pageHash: string;
        authHash: string;
        startTime = 0;
        userId: number;
        watchPopupActive : boolean;
        vts : number;
        quality : string;

        constructor(opt: VideoPlayerAfterLoadHandlerRequest) {
            var self = this;
            this.fileVideoPlayer = opt.fileVideoPlayer;
            this.lessonId = opt.lessonId;
            this.orderItemId = opt.orderItemId;
            this.fp = opt.fp;
            this.pageHash = opt.pageHash;
            this.authHash = opt.authHash;
            this.userId = opt.userId;
            this.watchPopupActive = opt.watchPopupActive;
            this.vts = opt.fp.vts;
            this.quality = "480p";

            var playCount = 0;

            var videoSettings = <VideoPlayerSettings>JSON.parse((opt.videoSettings as any).replaceAll("&quot;", '"'));

            if (opt.watchPopupActive) SweetAlert.swal_info_html("Önemli Bilgi", $("#WatchRuleModal").html());

            if (opt.videoUserLastSecond)
                this.fileVideoPlayer.currentTime(opt.videoUserLastSecond);

            //player üzerinde hata oluştuğunda
            this.fileVideoPlayer.on('error', function() {
                Q.notifyError("Video oynatılırken bir hata oluştu. Lütfen tekrar deneyiniz.");
            });

            // this.fileVideoPlayer.on('error', function(e) {
            //     // let error = self.fileVideoPlayer.error();
            //     // SweetAlert.swal_info_then("Bilgi", error, () => {
            //     //     //window.location.href = Q.resolveUrl("~/account/signout");
            //     // });
            //     Q.log(e);
            // });
                
            this.fileVideoPlayer.on("play", function() {
                if (playCount == 0) {
                    Logging.LessonWatchLogService.CheckLast({ Entity : { InsertUserId: self.userId, OrderItemId : self.orderItemId, LessonId: self.lessonId, AuthHash: self.authHash  }}, (r) => {
                        self.updateUserTime(WatchLogTypes.Play);
                        playCount++;
                    });
                } else {
                    self.updateUserTime(WatchLogTypes.Play);
                }
            });

            this.fileVideoPlayer.on("pause", function() {
                self.updateUserTime(WatchLogTypes.Pause);
            });

            // this.fileVideoPlayer.on('ended', function() {
            //     self.updateUserTime(WatchLogTypes.End);
            // });

            var signoutUser = function() {
                if (!self.fileVideoPlayer.paused()) {
                    self.fileVideoPlayer.pause();
                }
                SweetAlert.swal_info_then("Bilgi", "Çok fazla bu video üzerinde durduğunuz için oturumunuz sonlandırılmıştır. Lütfen tekrar giriş yapınız.", () => {
                    window.location.href = Q.resolveUrl("~/account/signout");
                });
            };

            // window.setTimeout(() => {

            //     if (!isNaN(self.vts) && self.vts > 100) {
            //     //Video ilk play devam ediyorsa video süresi kadar süre geçince oturumu sonlandır.
            //         window.setTimeout(() => {
            //             if (playCount == 1) {
            //                 signoutUser();
            //             }
            //         }, (self.vts * 2000));
            //     }
            // }, 5000);

            //3 dk de bir kontrol et
            window.setInterval(() => {
                Q.log("3 dk de bir kontrol et");
                Logging.LessonWatchLogService.GetLoginWatchTotalSecond({ Entity : { InsertUserId: self.userId, OrderItemId : self.orderItemId, LessonId: self.lessonId, AuthHash: self.authHash  }}, (r) => {
                    let durationx2 = (self.vts * 2);
                    // Q.information("Toplam İzlenen Saniye: " + r.Entity, () => { });
                    if (r.Entity >= durationx2) {
                        signoutUser();
                    } else {
                        if (!self.fileVideoPlayer.paused()) 
                        {
                            Q.log("3 dk de bir duraklatma kaydet");
                            self.resumePlay();
                        }
                    }
                });
            }, (3 * 60 * 1000));

            // window.setTimeout(() => {
            //     if (!isNaN(self.vts) && self.vts > 100) {
            //         //Video süresinin 1.5 katı kadar süre geçince oturumu sonlandır
            //         window.setTimeout(() => {
            //             signoutUser();
            //         }, (self.vts * 2000));
            //     }
            // }, 3000);

            // //video sonlanınca
            // this.fileVideoPlayer.on('ended', function() {
            //     // var entity = <Logging.UserEventLogRow>{};
            //     // entity.EntityId = self.lessonId;
            //     // entity.EntityType = 2; //2 Lesson
            //     // entity.EventType = "LearningStatusTrue"; //2 Lesson
            //     // Logging.UserEventLogService.Create({ Entity: entity }, ()=> {
            //     //     Q.notifySuccess("Tebrikler Dersi Bitti, Diğer Derse Geçiyorsunuz!");
            //     //     window.setTimeout(()=> {
            //     //         self.fileVideoPlayer.dispose();
            //     //         window.location.reload();
            //     //     });
            //     // });
            // });
            
            // if (opt.showWatermark == true)
            //     this.fileVideoPlayer.watermark({
            //         image: Q.resolveUrl('~/upload/' + videoSettings.WatermarkImage),
            //         url: 'https://www.miaacademia.com',
            //         position: 'top-left',
            //         fadeTime: null
            //     });
            if (opt.userBased == false) {
                this.fileVideoPlayer.newoverlay({
                    contentOfOverlay: (videoSettings.TcText as any).replaceAll("[TC]", loggedTc),
                    changeDuration: videoSettings.Speed ? videoSettings.Speed * 1000 : 10000
                });
            }

            this.fileVideoPlayer.hotkeys({
                volumeStep: 0.1,
                seekStep: 5,
                enableModifiersForNumbers: false
            });

            self.bindQualityselector();

            if (videoSettings.VisibilityChange == true) this.visibilitychange();
        }

        private resumePlay() {
            var self = this;
            var entity = {} as Logging.LessonWatchLogRow;
            entity.OrderItemId = self.orderItemId;
            entity.LessonId = self.lessonId;
            entity.LastSecond = self.fileVideoPlayer.currentTime();
            entity.TotalSecond = self.vts;
            entity.PageHash = self.pageHash;
            entity.AuthHash = self.authHash;
            Logging.LessonWatchLogService.InsertResumePlay({ Entity : entity }, (r) => {});
        }

        private bindQualityselector() {
            var self = this;

            let setQualityCookie = function (quality) {
                ($ as any).removeCookie('quality', { path: '/' });
                ($ as any).cookie('quality', quality, { expires: 7, path: '/' });
            }

            var qualities = [];
            qualities.push({
                src: self.fp.path + '&q=1080p',
                type: 'video/mp4',
                label: '1080p',
            });

            qualities.push({
                src: self.fp.path + '&q=720p',
                type: 'video/mp4',
                label: '720p'
            });

            qualities.push({
                src: self.fp.path + '&q=480p',
                type: 'video/mp4',
                label: '480p'
            });

            //kullanıcının seçtiği kaliteyi cookie'den oku
            var qualityCookie = ($ as any).cookie('quality');
            
            if (qualityCookie) {
                if (qualityCookie.indexOf('P') > -1) qualityCookie = qualityCookie.replace('P', 'p');
                var selectedQuality = Q.first(qualities, x => x.label == qualityCookie);
                if (selectedQuality) selectedQuality.selected = true;
            } else Q.first(qualities, x => x.label == '480p').selected = true;

            //kalite seçimi için buton ekle
            self.fileVideoPlayer.src(qualities);    
            let qualitySelectorButton = self.fileVideoPlayer.addChild('QualitySelector');
            let controlBar = self.fileVideoPlayer.controlBar.el();
            let fullscreenToggle = controlBar.querySelector('.vjs-playback-rate');
            controlBar.insertBefore(qualitySelectorButton.el(), fullscreenToggle);

            //kullanıcı kalite seçimi yaptığında video çalıyor ise duraklat
            self.fileVideoPlayer.on("qualityRequested", (event, newSource) => { 
                if (!self.fileVideoPlayer.paused()) self.fileVideoPlayer.pause();
            });
            
            //kullanıcı kalite seçimi yaptığında cookie'e yaz
            self.fileVideoPlayer.on("qualitySelected", (event, newSource) => setQualityCookie(newSource.label));
        }

        private visibilitychange() {
            var self = this;
            var focused = true; 
            var player_state = false;
            document.addEventListener("visibilitychange", function () {
            focused = !focused;
            if (!focused) {
                if (typeof self.fileVideoPlayer !== 'undefined') { 
                    if(self.fileVideoPlayer.paused()) player_state=true;
                       self.fileVideoPlayer.pause(); 
                    }
                } else {
                    if(player_state!=true) {
                       self.fileVideoPlayer.play();
                    }
                }
            });
        }

        private updateUserTime(t : WatchLogTypes) {
            var self = this;
            window.setTimeout(() => {
                var entity = {} as Logging.LessonWatchLogRow;
                entity.OrderItemId = self.orderItemId;
                entity.LessonId = self.lessonId;
                entity.LastSecond = self.fileVideoPlayer.currentTime();
                entity.TotalSecond = self.vts;
                entity.WatchLogType = t;
                entity.PageHash = self.pageHash;

                AgerLMS.Logging.LessonWatchLogService.Create({
                    Entity : entity
                }, ()=> {
                    //SweetAlert.swal_success(Q.text("WebSite.Text.Successfull"), Q.text("WebSite.Text.Successfull"));
                }, {
                    onError: (e) => {
                        Swal.fire({
                            icon: 'error',
                            title: Q.text("WebSite.Text.Error"),
                            text: e.Error.Message
                        })
                    }
                });
            }, 100);
        }

        private checkTimer() {
            window.setTimeout(() => {
                //logout

                Q.information("Videoyu çok fazla izlediniz.Sistemden çıkış yapılıyor", () => {
                    window.location.href = Q.resolveUrl("~/account/signout");
                });
            }, 1000 * 30);
        }

        // var myPlayer = videojs('videoPlayer');
        // myPlayer.on('timeupdate', function() {
        // console.log(this.currentTime());
        // });
    }
}